export default "__VITE_ASSET__CoycMVrQ__"